import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BankLimitsUpdateScheduleResponse } from '@interfaces/bank-limits/responses/bank-limits.response';
import { SharedModule } from '@shared/shared.module';
import { bankLimitScheduleView } from '@features/dashboard/dashboard-management/components/home-bank-limits-card/bank-limits-display.util';

/**
 * Linha do rodapé do card "Limites Bancários" sobre o pedido automático aos bancos (card 3787):
 * "Próximo pedido aos bancos: dd/MM/yyyy", "Pedido automático aos bancos desligado" ou "Nenhum
 * contato marcado...", com a frequência na tooltip. Some quando o backend não manda `limitUpdate`.
 */
@Component({
  selector: 'app-home-bank-limits-update-footer',
  standalone: true,
  imports: [SharedModule],
  template: `
    @if (view(); as line) {
      <span
        class="limits-schedule"
        [class.limits-schedule--off]="line.isOff"
        tabindex="0"
        [pTooltip]="line.tooltip"
        tooltipPosition="top">
        <i class="pi" [class.pi-calendar-clock]="!line.isOff" [class.pi-ban]="line.isOff"></i>
        {{ line.text }}
      </span>
    }
  `,
  styleUrls: ['./home-bank-limits-update-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBankLimitsUpdateFooterComponent {
  readonly schedule = input<BankLimitsUpdateScheduleResponse | null | undefined>(null);

  readonly view = computed(() => bankLimitScheduleView(this.schedule()));
}
